import { render, staticRenderFns } from "./PropertyMap.vue?vue&type=template&id=072c96ee&scoped=true"
import script from "./PropertyMap.vue?vue&type=script&lang=js"
export * from "./PropertyMap.vue?vue&type=script&lang=js"
import style0 from "./PropertyMap.vue?vue&type=style&index=0&id=072c96ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c96ee",
  null
  
)

export default component.exports